import { useIsMediaLightboxOpen } from '@ms/yammer-hooks/dist/mediaLightbox/store';
import type { FC } from 'react';
import React from 'react';

import MediaLightbox from './LoadableMediaLightbox';

const LazyMediaLightbox: FC = () => {
  const isShowing = useIsMediaLightboxOpen();

  return isShowing ? <MediaLightbox /> : null;
};

export default LazyMediaLightbox;
